import { render, staticRenderFns } from "./DomainsForm.vue?vue&type=template&id=0a60d12c&scoped=true&"
import script from "./DomainsForm.vue?vue&type=script&lang=js&"
export * from "./DomainsForm.vue?vue&type=script&lang=js&"
import style0 from "./DomainsForm.vue?vue&type=style&index=0&id=0a60d12c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a60d12c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow,VSpacer})
